module.exports = require("./lag.d.ts");